export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 5_05.0619c46e.jpg";